import { ReactElement } from 'react';

import { normalizeDateValue } from '@cashier/cashier-common';
import { Directions, FormField } from '@cashier/cashier-model';
import { useUIConfiguration } from '@cashier/cashier-shared';
import { cn, MaskedInput } from '@cashier/cashier-ui';

import {
  useCashierConfiguration,
  useFieldToucher,
  useFormPayloadItem,
} from '../../../../hooks';

import styles from './styles.module.scss';

interface DateFieldInterface {
  field: FormField;
}

export const DateField = ({ field }: DateFieldInterface): ReactElement => {
  const labelPosition = useUIConfiguration('input', 'label');
  const { direction } = useCashierConfiguration();

  const { touch } = useFieldToucher();
  const { isDisabled, validationStatus } = useFormPayloadItem(field.name);

  return (
    <div
      className={cn({
        [styles.rtl]: direction === Directions.Rtl,
      })}
    >
      <MaskedInput
        field={field}
        onChange={(value, isFocused) =>
          touch(
            {
              ...field,
              value: normalizeDateValue(value, field.params?.yearFormat),
            },
            {
              interactionCompleted: !isFocused,
            },
          )
        }
        labelPosition={labelPosition}
        validationStatus={validationStatus}
        isDisabled={isDisabled}
        direction={direction}
      />
    </div>
  );
};
